import { IRodLiftStatusWellModel } from '../../models/RodPumpWellStatus';
import api from '../../services/api';
import { buildApiHeaders } from '../../utilities/configUtils';

interface RodliftWellStatusResponse {
  data: {
    values: IRodLiftStatusWellModel;
  };
}

export const fetchRodliftWellStatusInitialState = async (assetId: string) => {
  const headers = await buildApiHeaders();

  return await api
    .get(`api/AssetStatus?assetId=${assetId}`, {
      headers,
    })
    .then(function (response: RodliftWellStatusResponse) {
      return response.data;
    });
};
